export default function showFormSuccessSelector(state) {
  return state.showSubmitSuccess ?? false;
}
